import { BoxIcon } from "src/icons/BoxIcon";
import { ChartIcon } from "src/icons/ChartIcon";
import { PendingIcon } from "src/icons/PendingIcon";
import { UsersIcon } from "src/icons/UsersIcon";
import KpiCard from "./KpiCard";

const Kpis = () => {
  return (
    <div className="grid grid-cols-350px gap-[40px]">
      <KpiCard
        title="Total Users"
        count={40689}
        icon={<UsersIcon />}
        iconWrapperClassName="bg-quratz"
      />
      <KpiCard
        title="Total Organizations"
        count={102}
        icon={<BoxIcon />}
        iconWrapperClassName="bg-frostProof"
      />
      <KpiCard
        title="Active Plans"
        count={14}
        icon={<ChartIcon />}
        iconWrapperClassName="bg-pampas"
      />
      <KpiCard
        title="Pending Invoices"
        count={2040}
        icon={<PendingIcon />}
        iconWrapperClassName="bg-mistyRose"
      />
    </div>
  );
};

export default Kpis;
